<template>
  <vs-row
    vs-type="flex"
    vs-align="center"
    class="pt-2">
    <vs-icon :icon="iconName" size="medium" :color="iconColor" v-if="iconName"/>
    <span class="pl-4">{{title}}</span>
  </vs-row>
</template>

<script>
  export default {
    name: "IconTitleItem",
    props: {
      iconName: {
        type: String
      },
      title: {
        type: String
      },
      iconColor: {
        type: String
      },
      textColor: {
        type: String
      }
    }
  }
</script>

<style scoped>

</style>
